<template>
  <v-container
    class="py-3 px-2"
    fluid
  >
    <v-layout wrap>
      <v-flex
        class="px-3"
        xs12
      >
        <v-select
          :item-text="'filename'"
          :item-value="'url'"
          :items="mySolarWindBoundaries"
          :loading="$apollo.queries.mySolarWindBoundaries.loading || $wait.is('uploading a solar wind boundary')"
          label="Filename"
          v-model="myRun.config.heliospheric_model.Data.solar_wind"
        >
          <template v-slot:append>
            <v-icon color="info">arrow_drop_down</v-icon>
            <UploadButton
              :fileChangedCallback="inputSolarWindBoundaryFile"
              class="mr-0"
              flat
              icon
              small
              title="Upload new"
            >
              <template slot="icon">
                <v-icon color="info">cloud_upload</v-icon>
              </template>
            </UploadButton>
          </template>
        </v-select>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<style>
.upload-btn {
  margin: 0 !important;
  padding: 0 !important;
}
.v-select__selections {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>

<script>
import { MY_SOLAR_WIND_BOUNDARIES, UPLOAD_SOLAR_WIND_BOUNDARY } from '@/graphql.gql';
import UploadButton from 'vuetify-upload-button';
import runMixin from '@/mixins/run';

export default {
  mixins: [runMixin],
  components: { UploadButton },
  apollo: {
    mySolarWindBoundaries: { query: MY_SOLAR_WIND_BOUNDARIES },
  },
  methods: {
    async inputSolarWindBoundaryFile(newSolarWindBoundaryFile) {
      if (!RegExp('.*.dat').test(newSolarWindBoundaryFile.name)) {
        this.$snackbar.show('Invalid solar wind boundary file. Should be a .dat file.');
        return;
      }
      try {
        this.$wait.start('uploading a solar wind boundary');
        await this.$apollo.mutate({
          mutation: UPLOAD_SOLAR_WIND_BOUNDARY,
          variables: { file: newSolarWindBoundaryFile },
          update: (store, { data: { uploadSolarWindBoundary } }) => {
            const data = store.readQuery({ query: MY_SOLAR_WIND_BOUNDARIES });
            data.mySolarWindBoundaries.unshift(uploadSolarWindBoundary);
            store.writeQuery({ query: MY_SOLAR_WIND_BOUNDARIES, data });
            this.myRun.config.heliospheric_model.Data.solar_wind = uploadSolarWindBoundary.url;
          },
        });
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
        this.$snackbar.show('We could upload your solar wind boundary. Please, try again.');
      } finally {
        this.$wait.end('uploading a solar wind boundary');
      }
    },
  },
};
</script>
